import * as React from 'react';
import Modal from './modal';
import Alert, { AlertCategoryEnum } from './Alert';
import { CoughAnalysisSetsFixedCommentsDisplay } from '../api/apiTypes';
import { CoughOverreadFixedComment } from '../../cough/analyse/interfaces/state';

export interface CommentsComparisonDialogProps {
    header: string;
    show: boolean;
    isViewOnly: boolean;
    primarySetId: string;
    sets: Array<CoughAnalysisSetsFixedCommentsDisplay>;
    comments: Array<CoughOverreadFixedComment>;
    onChange: (id: string, checked: boolean) => void;
    onClose: () => void;
}

interface CommentsWithSet {
    commentId: string;
    comment: string;
    sets: Array<SetState>;
}

interface SetState {
    set: CoughAnalysisSetsFixedCommentsDisplay;
    state: boolean;
}

export const CommentsComparisonDialog = (props: CommentsComparisonDialogProps) => {
    const [commentsWithSets, setCommentsWithSets] = React.useState<CommentsWithSet[]>([]);

    React.useEffect(() => {
        if (props.sets.length > 0 && props.comments.length > 0) {

            const comms = props.comments.map(com => {
                return {
                    commentId: com.id,
                    comment: com.comment,
                    sets: props.sets.map(set => {
                        return {
                            set: set,
                            state: set.FixedCommentIds.includes(com.id) ?
                                true : false,
                        }
                    }),
                }
            });

            setCommentsWithSets(comms);
        } else {
            setCommentsWithSets([]);
        }
    }, [props.comments, props.sets]);

    const renderHeads = (sets: Array<CoughAnalysisSetsFixedCommentsDisplay>) => {
        return (
            <tr key="commentsHeader">
            <th>Comment</th>
                {
                    sets.map(set => {
                        return (<th key={"TableHeader" + set.Id}>{set.Type.Name}</th>);
                    })
            }
            </tr>
        );
    }

    const renderRow = (row: CommentsWithSet, primarySetId: string) => {
        return (
            <tr key={"Row" + row.commentId}>
                <td>{row.comment}</td>
                {
                    row.sets.map(cell => {
                        return (<td key={cell.set.Id}>{renderCheckbox(row.commentId, cell.state, cell.set.Id === primarySetId)}</td>);
                    })
                }
            </tr>
        );
    }

    const renderCheckbox = (commentId: string, state: boolean, isPrimarySet: boolean) => {
        if (isPrimarySet) {
            return <input type="checkbox" disabled={props.isViewOnly} checked={state} onChange={() => props.onChange(commentId, !state) } />
        } else {
            if (state) {
                return <i className="text-success fas fa-check"></i>
            } else {
                return <i className="text-danger fas fa-times"></i>
            }
        }
    }

    const renderItems = () => {
        return commentsWithSets.map(i => {
            return renderRow(i, props.primarySetId);
        });
    }

    const renderModalBody = () => {
        if (commentsWithSets.length <= 0) {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    There are no fixed comments available
                </Alert>
            );
        }
        else {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div style={{ maxWidth: "100%", margin: "0 auto", overflowX: "auto" }}>
                            <table className="table" style={{ maxWidth: "100%", width: "100%", overflowX: "auto" }}>
                            <thead>
                                <tr key="setsHeader">
                                    <th></th>
                                    <th colSpan={props.sets.length}>Sets</th>
                                </tr>
                                {renderHeads(props.sets)}
                            </thead>
                            <tbody>
                                {renderItems()}
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            );
        }
    }

    if (props.show) {
        return (
            <Modal show={props.show} header={props.header} closeModalHandler={() => props.onClose()}>
                <div className="modal-body">
                    {renderModalBody()}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={() => props.onClose()}>OK</button>
                </div>
            </Modal>
        );
    } else {
        return null;
    }
}
